export default "__VITE_ASSET__DmMgMrd5__"